import get from 'lodash/get';
import { GET_USER_STATE_SUCCESS } from 'actions/userStateActions';
import * as marketplaceServiceabilityActions from 'actions/marketplaceServiceabilityActions';
const { MARKETPLACE_SERVICEABILITY_ACTIONS } = marketplaceServiceabilityActions;
const defaultState = false;
export default function marketplaceServiceability(state = defaultState, action) {
    switch (action.type) {
        case MARKETPLACE_SERVICEABILITY_ACTIONS.GET_MARKETPLACE_SERVICEABILITY_SUCCESS:
            return get(action.data, ['RESPONSE', 'value'], state);
        case GET_USER_STATE_SUCCESS:
            return get(action.data, ['RESPONSE', 'groceryEnabled'], state);
        default:
            return state;
    }
}
